<div class="bg">
    <fury-page>
      <fury-title class="title">
        <span *ngIf="!serviceId" [@fadeInRight]>Add Service Agreement</span>
        <span *ngIf="serviceId" [@fadeInRight]>Update Service Agreement</span>
      </fury-title>
    </fury-page>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
        <form [formGroup]="serviceAgreementForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput placeholder="Title" formControlName="title">
                <mat-error
                  *ngIf="serviceAgreementForm.controls['title'].touched && serviceAgreementForm.controls['title'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Order</mat-label>
                <input matInput type="number" min="1" placeholder="Order" formControlName="order">
                <mat-error
                  *ngIf="serviceAgreementForm.controls['order'].touched && serviceAgreementForm.controls['order'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error
                  *ngIf="serviceAgreementForm.controls['order'].touched && serviceAgreementForm.controls['order'].hasError('min')">
                  Minimum value should be 1.</mat-error>
              </mat-form-field>
            </div>
            
            <fxLayout fxLayout="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
              <mat-label>Content</mat-label>
              <ckeditor [config]="editorConfig" formControlName="content" debounce="500"></ckeditor>
              <mat-error
              *ngIf="serviceAgreementForm.controls['content'].touched && serviceAgreementForm.controls['content'].hasError('required')" style="font-size:13px;">
              This is a required field.</mat-error>
            </fxLayout>
            <mat-form-field appearance="outline">
              <mat-label>Item Type</mat-label>
              <mat-select formControlName="itemType" (selectionChange)="selectItemHandleChange($event)">
                <mat-option value="">None</mat-option>
                <mat-option value="appliances">Appliances</mat-option>
                <mat-option value="systems">Systems</mat-option>
                <mat-option value="optional">Optional</mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="serviceAgreementForm.value?.itemType">
            <div formArrayName="coveredItemDetail" class="coveredItemDetail">
              <div *ngFor="let item of coverItemDetails.controls; let i = index" class="coveredItem">
                <div [formGroupName]="i">
                  <mat-form-field appearance="outline">
                    <mat-label>Select Cover Item</mat-label>
                    <mat-select formControlName="id" (selectionChange)="selectCoverItemHandleChange($event, i)">
                      <mat-option *ngFor="let coverItem of planCoveredItems" [value]="coverItem?.planCoverItemId">{{coverItem?.title}}</mat-option>
                    </mat-select>
                    <mat-error
                    *ngIf="item.get('id').hasError('required')">
                      This is a required field.</mat-error>
                  </mat-form-field>
                  <fxLayout fxLayout="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
                    <mat-label><b>Content</b></mat-label>
                    <ckeditor [config]="editorConfig" formControlName="content"></ckeditor>
                    <mat-error
                    *ngIf="item.get('content').hasError('required') && item.get('content').touched">
                      This is a required field.</mat-error>
                  </fxLayout>
                  <div class="button_container" *ngIf="coverItemDetails.controls.length > 1">
                    <button mat-raised-button color="warn" (click)="deleteCoveredItem(i)">
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                    <div class="move_buttons">
                      <button mat-raised-button [disabled]="i === 0 || serviceAgreementForm?.controls?.coveredItemDetail?.status === 'INVALID'" (click)="moveCoveredItem(i, -1)">
                        <mat-icon>keyboard_arrow_up</mat-icon>
                      </button>
                      <button mat-raised-button [disabled]="i === coverItemDetails.controls.length - 1 || serviceAgreementForm?.controls?.coveredItemDetail?.status == 'INVALID'" (click)="moveCoveredItem(i, 1)">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" mat-raised-button color="primary" (click)="addCoveredItem()" [disabled]="
            serviceAgreementForm?.controls?.coveredItemDetail?.status === 'INVALID'">Add Content</button>
            </div>
          </div>
            
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="submit()">{{!serviceId ? 'Add' : 'Update'}}</button>
            
          </div>

          </form>
      </div>
    </div>
  </div>
  
  
  
